// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { TerceraChartWindow } from './Windows/TerceraChartWindow';
export class TerceraChartOverlayWindow extends TerceraChartWindow {
    constructor(rightYScaleRenderer, leftYScaleRenderer) {
        super(rightYScaleRenderer, leftYScaleRenderer);
        this.Overlay = null;
        this.TerceraChartOverlayWindow = true;
    }
    Dispose() {
        this.Overlay = null;
        super.Dispose();
    }
    OnLayout(info = null) {
        super.OnLayout(info);
        if (this.leftYScaleRenderer != null && info != null) {
            if (this.Overlay.chart.ActiveOverlayGet() === this.Overlay && this.Overlay.separateScale) {
                const clientR = this.ClientRectangle;
                this.leftYScaleRenderer.Visible = true;
                this.leftYScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
            }
            else {
                this.leftYScaleRenderer.Visible = false;
            }
        }
    }
    ThemeChanged() {
        var _a;
        super.ThemeChanged();
        (_a = this.Overlay) === null || _a === void 0 ? void 0 : _a.ThemeChanged();
    }
    drawWindowHeader(gr, curLayer) { }
    getActivePriceScale() {
        if (this.Overlay.separateScale) {
            return super.getActivePriceScale();
        }
        else {
            const mainWindow = this.Overlay.chart.mainWindow;
            return mainWindow.rightYScaleRenderer;
        }
    }
}
